import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f7fa761"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Les champs marqués d'un * doivent impérativement être complétés", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cut-line" }, null, -1))
const _hoisted_3 = { id: "SideButton" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_sign_up_account = _resolveComponent("sign-up-account")!
  const _component_sign_up_profile = _resolveComponent("sign-up-profile")!
  const _component_sign_up_company = _resolveComponent("sign-up-company")!
  const _component_loader_dots = _resolveComponent("loader-dots")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "SignUpView",
      class: _normalizeClass({ 'no-display': _ctx.isSignUping })
    }, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1),
        _hoisted_1,
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoTo('/signin')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.signin.use()
          }, null, 8, ["icon"]),
          _createTextVNode("Se connecter")
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "gray",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GoTo('/recovery')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.forgotten.use()
          }, null, 8, ["icon"]),
          _createTextVNode("Mot de passe oublié")
        ])
      ]),
      _createVNode(_component_sign_up_account, {
        id: "SignUpAccount",
        class: _normalizeClass(["signup-step", { slide: _ctx.showProfile, hidden: _ctx.isAccountCreated }]),
        onOnFormCompleted: _ctx.ShowProfile,
        error: _ctx.accountError
      }, null, 8, ["class", "onOnFormCompleted", "error"]),
      _createVNode(_component_sign_up_profile, {
        id: "SignUpProfile",
        class: _normalizeClass(["signup-step hidden", { show: _ctx.showProfile && !_ctx.isAccountCreated }]),
        onOnFormCompleted: _ctx.EnableButtons
      }, null, 8, ["class", "onOnFormCompleted"]),
      _createVNode(_component_sign_up_company, {
        id: "SignUpCompany",
        class: _normalizeClass(["signup-step hidden", { show: _ctx.IsFormCompanyAsked }]),
        onOnFormCompleted: _ctx.OnCompanyFormCompletedHandler,
        error: _ctx.companyError
      }, null, 8, ["class", "onOnFormCompleted", "error"]),
      _createElementVNode("div", {
        class: _normalizeClass(["buttons", { show: _ctx.showButtons }])
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["gray", { hide: _ctx.IsFormCompanyAsked }]),
          type: "button",
          disabled: !_ctx.showButtons,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ShowCompany && _ctx.ShowCompany(...args)))
        }, "Ajouter les détails de mon entreprise", 10, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ disabled: !(_ctx.accountCompleted && _ctx.profileCompleted), hide: _ctx.isAccountCreated }),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SendFormDatas && _ctx.SendFormDatas(...args)))
        }, "Créer mon compte", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ hide: !_ctx.isAccountCreated }),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SendCompanyData && _ctx.SendCompanyData(...args)))
        }, "Créer l'entreprise", 2)
      ], 2)
    ], 2),
    _createVNode(_component_loader_dots, {
      class: _normalizeClass(["loader-dots alone", { 'no-display': !_ctx.isSignUping }])
    }, null, 8, ["class"])
  ], 64))
}